// Display names for the different log-levels.
// The array index represents the log-level.
import { NgxLoggerLevel } from "ngx-logger";
import { LoggerConfigService } from "app/core/services/logger-config.service";
import { INGXLoggerMetadata } from "ngx-logger";

// Additional spaces added to always have 5 characters.
// Ensures equal indentation for everything after the log-level.
export function getLogLevelDisplayName(logLevel: NgxLoggerLevel): string {
  return LoggerConfigService.logLevels[logLevel].padEnd(5, " ");
}

/* eslint-disable no-console */
export function writeToConsole(
  log: INGXLoggerMetadata,
  ...args: string[]
): void {
  // Any additional parameters are passed into the console commands.
  // Can be used to render objects.
  if (log.additional) args.push(...log.additional);

  switch (log.level) {
    case NgxLoggerLevel.TRACE: {
      console.trace(...args);
      break;
    }
    case NgxLoggerLevel.DEBUG: {
      // Important note about Chrome:
      // In Chrome the debug logging is hidden by default.
      // Make sure 'Verbose' log-level is activated in the dev-tools.
      console.debug(...args);
      break;
    }
    case NgxLoggerLevel.INFO: {
      console.info(...args);
      break;
    }
    case NgxLoggerLevel.LOG: {
      console.log(...args);
      break;
    }
    case NgxLoggerLevel.WARN: {
      console.warn(...args);
      break;
    }
    default: {
      console.error(...args);
    }
  }
}

/* eslint-enable no-console */
